// CÓDIGO FINAL E MAIS INTELIGENTE para BrandLogo.tsx
import { cn } from "@/lib/utils";

type Align = "start" | "center" | "end";
type Size = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";

interface BrandLogoProps {
  className?: string;
  /** Classes extras na tag <img> (ex.: brilho em fundo escuro) */
  imgClassName?: string;
  showText?: boolean;
  justify?: Align;
  align?: Align;
  size?: Size;
  variant?: "default" | "compact" | "full";
}

const BrandLogo = ({
  className,
  imgClassName,
  showText = true,
  justify = "center",
  align = "center",
  size = "md",
  variant = "default",
}: BrandLogoProps) => {
  // Mapeia nossas props para as classes corretas do Tailwind
  const justifyClass = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
  }[justify];

  const alignClass = {
    start: "items-start",
    center: "items-center",
    end: "items-end",
  }[align];

  // Tamanhos da logo
  const sizeClasses = {
    xs: "w-10 h-10",
    sm: "w-16 h-16",
    md: "w-24 h-24",
    lg: "w-32 h-32",
    xl: "w-40 h-40",
    "2xl": "w-48 h-48",
    "3xl": "w-56 h-56",
    "4xl": "w-64 h-64",
    "5xl": "w-72 h-72",
  };

  // Variantes do layout
  const variantClasses = {
    default: "flex-col items-center gap-3",
    compact: "flex-row items-center gap-2",
    full: "flex-col items-center gap-4",
  };

  return (
    <div className={cn("flex w-full min-w-0", justifyClass, alignClass, className)}>
      <div className={cn("flex min-w-0", variantClasses[variant])}>
        <img
          src="/logoasad.png"
          alt="Allana Sthéfany Advocacia"
          className={cn(
            "object-contain object-center max-h-full max-w-full",
            sizeClasses[size],
            imgClassName
          )}
        />
        
        {showText && variant !== "compact" && (
          <div className="text-center">
            <h1 className="text-lg font-bold text-current">
              ALLANA STHEFANY
            </h1>
            <div className="flex items-center justify-center space-x-2 mt-1">
              <div className="h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent flex-1 max-w-8"></div>
              <span className="text-primary font-medium text-xs px-2">
                ADVOCACIA E CONSULTORIA JURÍDICA
              </span>
              <div className="h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent flex-1 max-w-8"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandLogo;